import VisualizationIndex from "@/components/processEditor/index.vue";
import VisualizationGate from "@/components/processEditor/Gateway.vue";
import VisualizationEditor from "@/components/visualization/Editor.vue";

// 시각화 관련 Path
const VisualizationRoute = {
  path: "/visualization",
  component: VisualizationIndex,
  meta: { requireAuth: true },
  children: [
    {
      path:'/visualization/gate',
      name:'VisualizationGateway',
      component: VisualizationGate
    },
    {
      path:'/visualization/editor',
      name:'VisualizationEditor',
      component: VisualizationEditor
    },
  ]
} ; 

export default VisualizationRoute ;